import _ from 'underscore';
import {
    UPDATE_INPUT_NEW_CAR,
    SUBMIT_NEW_CAR,
} from './types';
import {
    submitNewCarToFirebase,
} from '../helpers/firebase';

export function updateInputNewCar(car) {
    return {
        type: UPDATE_INPUT_NEW_CAR,
        payload: car,
    };
}

export function submitNewCar(car) {
    car.dateAdd = Date.now();

    const result = submitNewCarToFirebase(car);

    const carWithKey = _.extend(car, {key: result.key});

    return {
        type: SUBMIT_NEW_CAR,
        payload: carWithKey,
    };
}


// WEBPACK FOOTER //
// ./src/app/actions/new_car_actions.js